import { render, staticRenderFns } from "./DoKoRestrictionSoloJ.vue?vue&type=template&id=23f936d8&scoped=true&"
import script from "./DoKoRestrictionSoloJ.vue?vue&type=script&lang=ts&"
export * from "./DoKoRestrictionSoloJ.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoRestrictionSoloJ.vue?vue&type=style&index=0&id=23f936d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f936d8",
  null
  
)

export default component.exports